import React, { lazy, Suspense } from "react";
import "./App.min.css";
import { Routes, Route } from "react-router-dom";
import { Routes as MyRoutes } from "../routes/routes";
import { ToastContainer } from "react-toastify";
import { HomeLayout } from "../layout/homeLayout";
import { MainLayout } from "../layout/mainLayout";
import PageLoader from "../components/pageLoader";

const Home = lazy(() => import("../pages/home/index").then((m) => ({ default: m.Home })));
const About = lazy(() => import("../pages/about").then((m) => ({ default: m.About })));
const CustomSoftwareDevelopment = lazy(() =>
  import("../pages/services/customSoftwareDevelopment").then((m) => ({ default: m.CustomSoftwareDevelopment }))
);
const WebAppDevelopment = lazy(() =>
  import("../pages/services/webAppDevelopment").then((m) => ({ default: m.WebAppDevelopment }))
);
const CloudAndDevOps = lazy(() =>
  import("../pages/services/cloudAndDevOps").then((m) => ({ default: m.CloudAndDevOps }))
);
const QualityAssurance = lazy(() =>
  import("../pages/services/qualityAssurance").then((m) => ({ default: m.QualityAssurance }))
);
const MobileAppDevelopment = lazy(() =>
  import("../pages/services/mobileAppDevelopment").then((m) => ({ default: m.MobileAppDevelopment }))
);
const ProductEngineering = lazy(() =>
  import("../pages/services/productEngineering").then((m) => ({ default: m.ProductEngineering }))
);
const DatabaseAdministration = lazy(() =>
  import("../pages/services/databaseAdministration").then((m) => ({ default: m.DatabaseAdministration }))
);
const WebsiteSecurity = lazy(() =>
  import("../pages/services/WebsiteSecurity").then((m) => ({ default: m.WebsiteSecurity }))
);
const AspNetWebsites = lazy(() =>
  import("../pages/projects/aspNetWebsites").then((m) => ({ default: m.AspNetWebsites }))
);
const WordpressWebsites = lazy(() =>
  import("../pages/projects/wordpressWebsites").then((m) => ({ default: m.WordpressWebsites }))
);
const PhpWebsites = lazy(() =>
  import("../pages/projects/phpWebsites").then((m) => ({ default: m.PhpWebsites }))
);
const WebApplication = lazy(() =>
  import("../pages/projects/webApplication").then((m) => ({ default: m.WebApplication }))
);
const Technologies = lazy(() =>
  import("../pages/company/technologies").then((m) => ({ default: m.Technologies }))
);
const Career = lazy(() =>
  import("../pages/company/career").then((m) => ({ default: m.Career }))
);
const OurProcess = lazy(() =>
  import("../pages/company/ourProcess/index").then((m) => ({ default: m.OurProcess }))
);
const OutsourcingToPakistan = lazy(() =>
  import("../pages/company/outsourcingToPakistan").then((m) => ({ default: m.OutsourcingToPakistan }))
);
const WebDesigns = lazy(() =>
  import("../pages/designs/webDesigns").then((m) => ({ default: m.WebDesigns }))
);
const MobileApps = lazy(() =>
  import("../pages/designs/mobileApps").then((m) => ({ default: m.MobileApps }))
);
const GraphicsDesign = lazy(() =>
  import("../pages/designs/graphicsDesign").then((m) => ({ default: m.GraphicsDesign }))
);
const AldonApp = lazy(() =>
  import("../pages/designs/mobileApps/aldon").then((m) => ({ default: m.AldonApp }))
);
const FabrioApp = lazy(() =>
  import("../pages/designs/mobileApps/fabrio").then((m) => ({ default: m.FabrioApp }))
);
const FootBallApp = lazy(() =>
  import("../pages/designs/mobileApps/footBall").then((m) => ({ default: m.FootBallApp }))
);
const SparkyApp = lazy(() =>
  import("../pages/designs/mobileApps/sparky").then((m) => ({ default: m.SparkyApp }))
);
const LogoDesigns = lazy(() =>
  import("../pages/designs/logoDesigns").then((m) => ({ default: m.LogoDesigns }))
);
const Flyer = lazy(() =>
  import("../pages/designs/flyer").then((m) => ({ default: m.Flyer }))
);
const Brochures = lazy(() =>
  import("../pages/designs/brochures").then((m) => ({ default: m.Brochures }))
);
const CorporateIdentity = lazy(() =>
  import("../pages/designs/corporateIdentity").then((m) => ({ default: m.CorporateIdentity }))
);
const Contact = lazy(() =>
  import("../pages/contact").then((m) => ({ default: m.Contact }))
);

function App() {
  return (
    <div className="App">
      <ToastContainer limit={2} newestOnTop theme="light" />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route element={<HomeLayout />}>
            <Route path={MyRoutes.home} element={<Home />} />
          </Route>
          <Route element={<MainLayout />}>
            <Route path={MyRoutes.about} element={<About />} />
            <Route
              path={MyRoutes.customSoftwareDevelopment}
              element={<CustomSoftwareDevelopment />}
            />
            <Route
              path={MyRoutes.webAppDevelopment}
              element={<WebAppDevelopment />}
            />
            <Route path={MyRoutes.cloudAndDevOps} element={<CloudAndDevOps />} />
            <Route
              path={MyRoutes.qualityAssurance}
              element={<QualityAssurance />}
            />
            <Route
              path={MyRoutes.mobileAppDevelopment}
              element={<MobileAppDevelopment />}
            />
            <Route
              path={MyRoutes.productEngineering}
              element={<ProductEngineering />}
            />
            <Route
              path={MyRoutes.databaseAdministration}
              element={<DatabaseAdministration />}
            />
            <Route path={MyRoutes.cyberSecurity} element={<WebsiteSecurity />} />
            <Route path={MyRoutes.aspNetWebsites} element={<AspNetWebsites />} />
            <Route
              path={MyRoutes.wordpressWebsites}
              element={<WordpressWebsites />}
            />
            <Route path={MyRoutes.phpWebsites} element={<PhpWebsites />} />
            <Route path={MyRoutes.webApplication} element={<WebApplication />} />
            <Route path={MyRoutes.technologies} element={<Technologies />} />
            <Route path={MyRoutes.career} element={<Career />} />
            <Route path={MyRoutes.ourProcess} element={<OurProcess />} />
            <Route
              path={MyRoutes.outsourcingToPakistan}
              element={<OutsourcingToPakistan />}
            />
            <Route path={MyRoutes.webDesigns} element={<WebDesigns />} />
            <Route path={MyRoutes.mobileApps} element={<MobileApps />} />
            <Route path={MyRoutes.graphicsDesigns} element={<GraphicsDesign />} />
            <Route path={MyRoutes.aldonApp} element={<AldonApp />} />
            <Route path={MyRoutes.fabrioApp} element={<FabrioApp />} />
            <Route path={MyRoutes.footBallApp} element={<FootBallApp />} />
            <Route path={MyRoutes.sparkyApp} element={<SparkyApp />} />
            <Route path={MyRoutes.logoDesigns} element={<LogoDesigns />} />
            <Route path={MyRoutes.flyer} element={<Flyer />} />
            <Route path={MyRoutes.brochures} element={<Brochures />} />
            <Route
              path={MyRoutes.corporateIdentity}
              element={<CorporateIdentity />}
            />
            <Route path={MyRoutes.contac} element={<Contact />} />
          </Route>
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
